import { useMemo } from 'react'
import { Stack } from '@leroy-merlin-br/backyard-react'
import PropTypes from 'prop-types'

import { Collapse, CollapseTitle } from 'site/Collapse'

import { Timeline } from 'checkout/components/MyOrders/components/Timeline'
import ShipmentContent from 'checkout/components/MyOrders/components/Shipment/Content'
import PaymentInfo from 'checkout/components/MyOrders/components/Payment/Info'
import { ServiceContent } from 'checkout/components/MyOrders/components/Service'
import {
  DeliveryAttemptBuilder,
  DisclaimerBuilder
} from 'checkout/components/MyOrders/components/DisclaimerBuilder'
import { isOnlinePickup } from 'checkout/components/MyOrders/modules/messages/shipment'

const OrderContent = ({
  id,
  date,
  discount,
  isOpen,
  payable,
  payments,
  shipments,
  shippingCost,
  steps,
  totalValue,
  services,
  hasOrderToPickUp = false,
  hasSeparationProblem = false
}) => {
  const hasServices = services?.items.length > 0

  const hasSteps = steps && Object.entries(steps) > 0

  const hasShipments = shipments?.length > 0
  const shipmentSteps = hasShipments ? shipments[0].steps : []
  const currentStep = shipmentSteps.find(step => step.current)

  const storeName = useMemo(
    () =>
      hasShipments &&
      shipments.reduce((accumulator, shipment) => {
        if (isOnlinePickup(shipment.type)) {
          accumulator = shipment.shippingAddress.storeName
        }

        return accumulator
      }, ''),
    [hasShipments, shipments]
  )

  const listServices = services?.items.map(service => ({
    ...service,
    isStandaloneService: !service.relatedProduct.id
  }))

  return (
    <Stack space="kilo">
      <DisclaimerBuilder
        orderId={id}
        orderDate={date}
        currentStep={currentStep}
        payment={payments[0]}
        storeName={storeName}
        hasOrderToPickUp={hasOrderToPickUp}
        hasSeparationProblem={hasSeparationProblem}
      />

      {hasSteps && <Timeline steps={steps} />}

      {hasShipments &&
        shipments.map((shipment, index) => (
          <Stack key={index} space="kilo">
            <DeliveryAttemptBuilder
              slug={shipment.steps.find(step => step.current)?.slug}
            />

            <Collapse
              className="order-content"
              isOpen={isOpen}
              title={
                <CollapseTitle {...shipment} quantity={shipment.items.length} />
              }
              content={<ShipmentContent {...shipment} />}
            />
          </Stack>
        ))}

      {hasServices &&
        listServices.map((service, index) => (
          <Collapse
            className="order-content"
            key={index}
            isOpen={false}
            title={<CollapseTitle {...service} type="Serviços" />}
            content={
              <ServiceContent
                {...service}
                address={services.installationAddress}
              />
            }
          />
        ))}

      <PaymentInfo
        payable={payable}
        payments={payments}
        totalValue={totalValue}
        shippingCost={shippingCost}
        discount={discount}
      />
    </Stack>
  )
}

OrderContent.propTypes = {
  date: PropTypes.string,
  totalValue: PropTypes.object,
  discount: PropTypes.object,
  shippingCost: PropTypes.object,
  shipments: PropTypes.array,
  payments: PropTypes.array,
  steps: PropTypes.array
}

export default OrderContent
